import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService } from 'src/app/services/convert.service';
import { IRegisterTestingResult } from 'src/app/interfaces/enrollment';
import { EnrollmentStore } from 'src/app/stores/enrollment/enrollment.store';
import { RegisterTesting } from 'src/app/stores/enrollment/registerTesting.store';

@Component({
  selector: 'app-add-register-test-result',
  templateUrl: './add-register-test-result.component.html',
  styleUrls: ['./add-register-test-result.component.scss']
})
export class AddRegisterTestResultComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  TITLE = "Placement Test Result"

  form: FormGroup;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  CLASS_LIST: any;


  constructor(
    public dialogRef: MatDialogRef<AddRegisterTestResultComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: EnrollmentStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private testing:RegisterTesting,
  ) { }


  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  ngOnInit() {
    this.form = this.fb.group({
      math: [null, Validators.compose([Validators.required])],
      physic: [null, Validators.compose([Validators.required])],
      chemistry: [null, Validators.compose([Validators.required])],
      biology: [null, Validators.compose([Validators.required])],
      earth: [null, Validators.compose([Validators.required])],
      writhing: [null, Validators.compose([Validators.required])],
      description: [null],
    })
    const { ITEM } = this.data;
    if (ITEM) {
      const { writhing, description, math, physic, chemistry, biology, earth } = ITEM;
      this.form.patchValue({
        writhing, description, math, physic, chemistry, biology, earth
      })
    }
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    if (this.form.valid) {
      this.processClose = isDraft ? false : true;
      this.processNew = isDraft;
      this.form.disable();
      const { ITEM } = this.data;
      const { selectedCompanyKey, user } = this.auth;
      this.error = null;
      this.isCreate = true;
      const { writhing, description, math, physic, chemistry, biology, earth } = f;
      const registerStatus = STATUS_OBJECT.submitted;
      const item: IRegisterTestingResult = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ITEM ? ITEM.page_key : ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${name}`.trim()),
        organizationRef: null,
        organizationKey: selectedCompanyKey,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        description: description || null,
        writhing:ConvertService.toNumber(writhing),
        math:ConvertService.toNumber(math),
        physic:ConvertService.toNumber(physic),
        chemistry:ConvertService.toNumber(chemistry),
        biology:ConvertService.toNumber(biology),
        earth:ConvertService.toNumber(earth),
        total:ConvertService.toNumber(writhing)+ConvertService.toNumber(math)+ConvertService.toNumber(physic)+ConvertService.toNumber(chemistry)+ConvertService.toNumber(biology)+ConvertService.toNumber(earth)
      }

      this.testing.setResult(item,ITEM, (success, res) => {
        if (success) {
          this.snackBar.open("Result has been added successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        if (!isNew) {
          this.dialogRef.close();
        }
      })
    }
  }
}
